import { render, staticRenderFns } from "./CardCurrentTicket.vue?vue&type=template&id=10f2b074&"
import script from "./CardCurrentTicket.vue?vue&type=script&lang=js&"
export * from "./CardCurrentTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports